module.exports = __webpack_public_path__ + "img/fuwubuzhouIta.368a0255.png";